import { AccountTransactions } from "../account/AccountTransactions"
import React from 'react';
import { useCurrentAgreementId } from "../utils/route-hooks"
import { useAccount } from "../state/AppDataStateProvider";

export const AccountTransactionsPage: React.FC = () => {
    const agreementId = useCurrentAgreementId()
    const account = useAccount()

    return (
        <>
            <AccountTransactions accountId={account?.id} agreementId={agreementId} />
        </>
    )
}